/* istanbul ignore file */
import React from 'react';
import { FINANCE_TYPES } from 'domain/people/employee/finance/shared/financeService';
import { EnumDropdown, EnumDropdownProps } from 'framework/form';

const FinanceTypeDropdown = (props: Omit<EnumDropdownProps, 'options'>) => {
  const options = { ...FINANCE_TYPES };

  return <EnumDropdown options={options} placeholder="Select type" {...props} />;
};

export default FinanceTypeDropdown;
